import HistoricalOrderDetailInquiry from './historical-order-detail-inquiry.vue'
export default HistoricalOrderDetailInquiry
